import { useTranslation } from 'react-i18next';
import { Box } from '../../../shared/layouts';
import { formatAppointmentDate } from '../../../../utils/dateHelpers';
import { useEffect, useState } from 'react';
import Header from '../../../shared/Header';
import SpecificDatePicker from './SpecificDatePicker';
import QuickDatePicker from './QuickDatePicker';

const DateTimeStep = ({
  start_date,
  availability,
  handleChangeAppointment,
  setDisabled,
  isEditing,
  exisitingAppointment,
  isLoading
}) => {
  const { t } = useTranslation();
  const {
    time: setTime = '',
    date: setDate,
    dateTime: setDateTime
  } = formatAppointmentDate(start_date);
  const [useSpecific, setUseSpecific] = useState(isEditing);

  useEffect(() => {
    handleChangeAppointment({
      target: { name: 'start_date', value: null }
    });
  }, []);

  useEffect(() => {
    if (setDate && setTime && setTime !== '00:00') {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [setDate, setTime]);

  useEffect(() => {
    if (isEditing) {
      setDisabled(exisitingAppointment === setDateTime || setTime === '00:00');
    }
  }, [isEditing, exisitingAppointment, setDateTime, setTime]);

  if (isLoading) {
    return (
      <>
        <Header title={t('Een moment geduld...')} variant={'section'} />
        <Box fontWeight={'bold'} fontScale={'l'}>
          {t('De beschikbare tijden worden opgehaald')}
        </Box>
      </>
    );
  } else if (availability?.dates?.length === 0) {
    return (
      <>
        <Header title={t('Probeer het opnieuw')} variant={'section'} />
        <Box fontWeight={'bold'} fontScale={'l'}>
          {t('Geen beschikbare tijden gevonden')}
        </Box>
      </>
    );
  }

  return (
    <>
      <Header title={t('Kies een datum en tijd')} variant={'section'} />
      {useSpecific || isEditing ? (
        <SpecificDatePicker
          {...{
            start_date,
            availability,
            handleChangeAppointment,
            exisitingAppointment
          }}
        />
      ) : (
        <QuickDatePicker
          {...{
            start_date,
            availability,
            handleChangeAppointment,
            setUseSpecific
          }}
        />
      )}
    </>
  );
};

export default DateTimeStep;
